// Carousel Templates
// This file contains predefined templates for the carousel generator

const carouselTemplates = [
  {
    id: 'simple-business',
    name: 'Simple Business',
    category: 'business',
    thumbnail: '/images/templates/carousel-simple-business.png',
    template: {
      name: 'Simple Business',
      pages: [
        {
          id: 'page-1',
          elements: [
            {
              id: 'heading-1',
              type: 'text',
              x: 100,
              y: 200,
              width: 800,
              height: 100,
              text: 'Your Business Title Here',
              fontSize: 48,
              fontFamily: 'Inter',
              fontWeight: 'bold',
              fill: '#2D3748',
              textAlign: 'center',
              draggable: true
            },
            {
              id: 'subtitle-1',
              type: 'text',
              x: 100,
              y: 350,
              width: 800,
              height: 80,
              text: 'Add your compelling subtitle or key message here',
              fontSize: 24,
              fontFamily: 'Inter',
              fontWeight: 'normal',
              fill: '#4A5568',
              textAlign: 'center',
              draggable: true
            },
            {
              id: 'cta-bg',
              type: 'rect',
              x: 350,
              y: 500,
              width: 300,
              height: 60,
              fill: '#3182CE',
              rx: 8,
              ry: 8,
              draggable: true
            },
            {
              id: 'cta-text',
              type: 'text',
              x: 350,
              y: 515,
              width: 300,
              height: 30,
              text: 'Get Started',
              fontSize: 20,
              fontFamily: 'Inter',
              fontWeight: 'bold',
              fill: '#FFFFFF',
              textAlign: 'center',
              draggable: true
            }
          ]
        },
        {
          id: 'page-2',
          elements: [
            {
              id: 'heading-2',
              type: 'text',
              x: 100,
              y: 150,
              width: 800,
              height: 100,
              text: 'Why Choose Us?',
              fontSize: 48,
              fontFamily: 'Inter',
              fontWeight: 'bold',
              fill: '#2D3748',
              textAlign: 'center',
              draggable: true
            },
            {
              id: 'point-1',
              type: 'text',
              x: 150,
              y: 300,
              width: 700,
              height: 60,
              text: '✓ Professional Quality Service',
              fontSize: 24,
              fontFamily: 'Inter',
              fontWeight: 'normal',
              fill: '#2D3748',
              textAlign: 'left',
              draggable: true
            },
            {
              id: 'point-2',
              type: 'text',
              x: 150,
              y: 380,
              width: 700,
              height: 60,
              text: '✓ Fast and Reliable Results',
              fontSize: 24,
              fontFamily: 'Inter',
              fontWeight: 'normal',
              fill: '#2D3748',
              textAlign: 'left',
              draggable: true
            },
            {
              id: 'point-3',
              type: 'text',
              x: 150,
              y: 460,
              width: 700,
              height: 60,
              text: '✓ 24/7 Customer Support',
              fontSize: 24,
              fontFamily: 'Inter',
              fontWeight: 'normal',
              fill: '#2D3748',
              textAlign: 'left',
              draggable: true
            }
          ]
        }
      ],
      canvasSettings: {
        width: 1080,
        height: 1080,
        background: '#FFFFFF'
      }
    }
  }
];

// Use CommonJS export syntax for Node.js backend compatibility
module.exports = carouselTemplates; 